import { render } from "./HelpMail.vue?vue&type=template&id=4f194266&scoped=true"
import script from "./HelpMail.vue?vue&type=script&lang=js"
export * from "./HelpMail.vue?vue&type=script&lang=js"

import "./HelpMail.vue?vue&type=style&index=0&id=4f194266&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f194266"]])

export default __exports__